import * as core from '../../../../../../../core'
import * as stakeholderTrainingAudience from '../stakeholder-training-audience'

export const RESOURCE = {
  payload: {
    description: 'No Training Expected',
    enumId: core.dms.models.Enum.Id.from({
      partialId: stakeholderTrainingAudience.RESOURCE.payload.partialId,
    }),
    id: 'No Training Expected',
    name: 'No Training Expected',
  },
  type: core.quiver.Resource.Type.DmsEnumEntry,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEnumEntry>
